//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'user'
let resource_name = 'usuario'
let resource_name_plural = 'usuarios'

let state = {

}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource.map(u => {
          u.error = false
          return u
        }))
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  // search for broadcast
  async search ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/search`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('setItems', res.data.resource.map(u => {
          u.error = false
          return u
        }))
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async updateBotStatus ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/updateBotStatus`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando estado del bot del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando estado del bot del ${resource_name}.`})
      console.error(e)
    }
  },
  async contact ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/contact`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo contacto de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo contacto de ${resource_name}.`})
      console.error(e)
    }
  },
  async cases ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/cases`, { params: params.params || {} })

      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo casos de ${resource_name}.` })
      }
    } catch (e) {
      if (params.callback) {
        params.callback({ error: `Ocurrió un error obteniendo casos de ${resource_name}.` })
      }

      console.error(e)
    }
  },
  async properties ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/properties`, { params: params.params || {} })

      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo propiedades de ${resource_name}.` })
      }
    } catch (e) {
      if (params.callback) {
        params.callback({ error: `Ocurrió un error obteniendo propiedades de ${resource_name}.` })
      }

      console.error(e)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
